import Splide from '../../node_modules/@splidejs/splide/dist/js/splide.min.js';

export function createHomeCarousel(progressBar) {
    /*these are default options overwritten by the data-splide attribute on the html tag*/
    let carousel = new Splide("#home-carousel", {
        type: "loop",
        speed: 1000,
        fixedWidth: "90%",
        pagination: false,
        isNavigation: true,
        padding: "3rem 3rem 0 0",
        breakpoints: {
            /*media query for under lg breakpoint*/
            768: {
                padding: "0",
                fixedWidth: "100%",
            },
        },
    });

    if (progressBar) {
        let bar = $(".dp-home-carousel-progress-bar");

        carousel.on("mounted move", function () {
            let end = carousel.Components.Controller.getEnd() + 1;
            let rate = Math.min((carousel.index + 1) / end, 1);
            bar.css("width", String(100 * rate) + "%");
        });
    }

    carousel.mount();
}

export function createContentCarousel(id, progressBar) {
    /*options here can be overriden by data-splide attribute on the carousel html element
      so here we can put the defaults and then pass customization by data-splide attribute*/
    let carousel = new Splide(`#${id}`, {
        type: "loop",
        fixedWidth: "100%",
        pagination: false,
        isNavigation: true,
        speed: 1000,
        autoplay: true,
    });

    if (progressBar) {
        let bar = $(`#${id} .dp-content-carousel-progress-bar`);

        carousel.on("mounted move", function () {
            let end = carousel.Components.Controller.getEnd() + 1;
            let rate = Math.min((carousel.index + 1) / end, 1);
            bar.css("width", String(100 * rate) + "%");
        });
    }

    carousel.mount();
}